var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoAccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 147,
  height: 170,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8D8D8D",
  fillOpacity: 0.2,
  d: "M115.6 0H32a5 5 0 0 0-5 5v147a5 5 0 0 0 5 5h110a5 5 0 0 0 5-5V32.708z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BBBCBC",
  d: "m116 0 31 32h-26a5 5 0 0 1-5-5z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF8201",
  d: "M35.338 143.67v-15.9q8.063-.387 12.585-3.878 4.621-3.49 4.621-9.598v-1.358q0-4.944-3.146-7.853-3.146-3.005-8.456-3.005-5.703 0-9.143 3.199-3.345 3.2-4.523 8.144L20 110.706a25 25 0 0 1 2.556-5.914 20.2 20.2 0 0 1 4.326-5.041q2.655-2.23 6.195-3.49T41.237 95q9.144 0 14.454 4.945Q61 104.889 61 113.324q0 4.654-1.672 8.144-1.572 3.393-4.129 5.817a20.6 20.6 0 0 1-5.8 3.878q-3.246 1.455-6.49 2.036v10.471zM39.173 165q-3.147 0-4.621-1.551-1.377-1.551-1.377-4.072v-1.261q0-2.52 1.377-4.072 1.474-1.551 4.62-1.551t4.523 1.551q1.476 1.552 1.475 4.072v1.261q0 2.52-1.475 4.072Q42.32 165 39.173 165"
})));
export default SvgNoAccess;